export default __webpack_public_path__ + "static/media/Brittle Blade Honormask.10cf7691.jpg";